import { render } from "./RanksCard.vue?vue&type=template&id=622a08f9&scoped=true&ts=true"
import script from "./RanksCard.vue?vue&type=script&lang=ts"
export * from "./RanksCard.vue?vue&type=script&lang=ts"

import "./RanksCard.vue?vue&type=style&index=0&id=622a08f9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622a08f9"]])

export default __exports__